module.exports = __webpack_public_path__ + "fonts/22acb39.ttf";